import {getCurrentInstance} from "@/shared/composables/vue-component-instance";

export const t = (key) => {
  const instanceProxy = getCurrentInstance().proxy;
  return instanceProxy.$t ? instanceProxy.$t(key) : key;
};
